export const environment = {
  production: true,
  baseUrl: 'https://poker.tomshanan.com',
  webSocketUrl: 'wss://poker-api.litman.uk/ws/',
};
